/*
 * @Date: 2022-07-05 19:57:56
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
import home from './home'
import about from './about'
import disclosure from './disclosure'
import finance from './finance'
import esg from './esg'


export default [
  home,
  about,
  disclosure,
  finance,
  esg,
  // 错误页
  {
      name: "notFound",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/error-page-404/index.vue"),
      meta: {
        title: "404 Not Found",
        needAuth: false,
      },
  },
]